var map = {
	"./vtex": [
		61070,
		70
	],
	"./vtex/": [
		61070,
		70
	],
	"./vtex/index": [
		61070,
		70
	],
	"./vtex/index.ts": [
		61070,
		70
	],
	"./vtex/search": [
		49572,
		572
	],
	"./vtex/search.ts": [
		49572,
		572
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 46870;
module.exports = webpackAsyncContext;